import styled, { css } from 'styled-components';
import { Typography } from '../../ui/Typography';
import { Breakpoints } from '../../../styled/constants';
import { ellipsisText, FlexColumn, FlexibleDiv } from '../../../styled/common';
import { tagStyles } from '../../ui/Typography/styles';

export const CARD_WIDTH = 300;
export const CARDS_GAP = 20;

export const VideoSectionContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 14px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 15px;
    padding: 30px 40px;
  }
`;

export const VideoSectionHead = styled(FlexColumn)`
  gap: 10px;
  margin-bottom: 20px;

  @media (min-width: ${Breakpoints.tablet}px) {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;
  }
`;

export const sliderButtonsStyles = css`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
`;

export const VideSectionTitle = styled(Typography)`
  @media (min-width: ${Breakpoints.tablet}px) {
    ${tagStyles.title_3_desc};
  }
`;

export const VideoSectionContent = styled(FlexibleDiv)`
  overflow-x: hidden;
  scroll-behavior: smooth;

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: ${CARDS_GAP}px;
  }
`;

export const ContentItem = styled.div`
  flex: 0 0 100%;
  scroll-snap-align: start;

  @media (min-width: ${Breakpoints.tablet}px) {
    flex: 0 0 ${CARD_WIDTH}px;
  }
`;

export const ConstructionTitle = styled(Typography)`
  display: block;
  margin: 10px 0 5px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin: 15px 0 5px;
    ${tagStyles.h3};
  }
`;

export const ConstructionDescription = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.secondary};
  ${ellipsisText};
`;
